<div class="all-content">
    <div class="row row-end">
      <div class="button-upload" (click)="newStrategicPlanning()" [ngClass]="!parameters.isEdit ? 'disabled' : 'pointer'">
          {{ getLanguages('new') }}
      </div>
    </div>

    <div class="no-data" *ngIf="!isData()">
        <div class="circle">
          <i class="fas fa-exclamation"></i>
        </div>
        {{ getLanguages('errors/noData') }}
    </div>

    <div class="row" *ngIf="isData()">
        <p-table *ngIf="getDisplayedRows().length !== 0" [value]="getDisplayedRows()" class="table-project" [sortField]="'organization'" [sortOrder]="1">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="organization" class="td-20">
                <span> {{ getLanguages('businessSolution/modal/strategicPlanning/organization') }} </span>
                <p-sortIcon field="organization"></p-sortIcon>
              </th>
              <th pSortableColumn="name" class="td-20">
                <span> {{ getLanguages('businessSolution/modal/strategicPlanning/name') }} </span>
                <p-sortIcon field="name"></p-sortIcon>
              </th>
              <th pSortableColumn="action" class="td-15">
                <span> {{ getLanguages('businessSolution/modal/strategicPlanning/action') }} </span>
                <p-sortIcon field="action"></p-sortIcon>
              </th>
              <th pSortableColumn="result" class="td-15">
                <span> {{ getLanguages('businessSolution/modal/strategicPlanning/result') }} </span>
                <p-sortIcon field="result"></p-sortIcon>
              </th>
              <th pSortableColumn="date" class="td-15">
                <span> {{ getLanguages('businessSolution/modal/strategicPlanning/date') }} </span>
                <p-sortIcon field="date"></p-sortIcon>
              </th>
              <th class="td-15">
                <span> {{ getLanguages('attachment/action') }} </span>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
            <tr>
              <td>
                <div class="item td-20">
                  <button class="button-menu-table" [disabled]="!parameters.isEdit" [ngClass]="!parameters.isEdit ? 'no-pointer' : ''" [matMenuTriggerFor]="responsibleOrganization">
                    <span>
                      {{ row.organization ? row.organization : getLanguages('select') }}
                    </span>
                    <i class="fa-solid fa-caret-down" *ngIf="parameters.isEdit"></i>
                  </button>    
                  <mat-menu #responsibleOrganization="matMenu">
                    <div class="menu">
                      <div class="input" (click)="$event.stopPropagation()">
                        <input type="text" [(ngModel)]="searchOrganizationResponsible" placeholder="{{ getLanguages('search') }}">
                        <i class="fa-solid fa-magnifying-glass"></i>
                      </div>
                      <div class="scroll">
                        <ng-container *ngFor="let item of organizationResponsibleArray">
                          <ng-container *ngIf="item?.name?.toLowerCase().includes(searchOrganizationResponsible?.toLowerCase())">
                            <div class="item-menu" (click)="choseItemSelect('responsibleOrganization', item, row)">
                              <span [ngClass]="item?.name == row?.organization ? 'valid-span' : 'invalid-span'">
                                {{ item.name }}
                              </span>
                            </div>
                          </ng-container>
                        </ng-container>
                      </div>
                    </div>
                  </mat-menu>
                </div>
              </td>
              <td class="td-20">
                <textarea [disabled]="!parameters.isEdit" [(ngModel)]="row.name"></textarea>
              </td>
              <td class="td-15">
                <textarea [disabled]="!parameters.isEdit" [(ngModel)]="row.action"></textarea>
              </td>
              <td class="td-15">
                <textarea [disabled]="!parameters.isEdit" [(ngModel)]="row.result"></textarea>
              </td>
              <td class="td-15">
                <textarea 
                  [disabled]="!parameters.isEdit" 
                  [(ngModel)]="row.date"
                  (input)="formatContent($event, row)"
                  (keypress)="validateInput($event, row)"
                  [maxlength]="10"
                  [placeholder]="getPlaceholder(row.type)">
                </textarea>
              </td>
              <td class="td-15">
                <div class="align-center" [ngClass]="!parameters.isEdit ? 'disabled-icon' : 'icon'">
                  <i class="fas fa-trash pointer" (click)="deleteStrategicPlanning(row.uuid)" [ngClass]="!parameters.isEdit ? 'disabled-icon no-pointer' : 'icon'"></i>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
    </div>
    <div class="div-paginator" *ngIf="isData()">
      <div class="paginator">
        <span>
          {{ getLanguages('businessSolution/modal/strategy/itensPage') }}
        </span>
        <button [matMenuTriggerFor]="menu" class="itens-per-page">
          {{ getItemsPerPage() }}
        </button>
        <mat-menu #menu="matMenu" >
          <button mat-menu-item (click)="choseItemsPage(5)">5</button>
          <button mat-menu-item (click)="choseItemsPage(10)">10</button>
        </mat-menu>
        <span>
          {{ getLanguages('businessSolution/modal/strategy/totalPages') }}
        </span>
        <span class="totalPages">
          {{ getTotalPages()}}
        </span>
        <button
          [ngClass]="getCurrentPages() === 1 ? 'disabled-arrow' : 'arrow'"
          [disabled]="getCurrentPages() === 1"
          (click)="onPageChange(getCurrentPages() - 1, 'strategy')">
          <i class="fa-solid fa-angle-left"></i>
        </button>
        <input type="number" [ngModel]="getCurrentPages()"  (blur)="checkValue()">
        <button
          [ngClass]="getCurrentPages() == getTotalPages() ? 'disabled-arrow' : 'arrow'"
          [disabled]="getCurrentPages() == getTotalPages()"
          (click)="onPageChange(getCurrentPages() + 1, 'strategy')">
          <i class="fa-solid fa-angle-right"></i>
        </button>
      </div>
    </div>  
</div>

<div class="background-modals" *ngIf="createResponsibleOrganogram">
  <div class="modal-create-type">
    <div class="modal-create-top">
      <div class="modal-create-toggle"></div>

      <div class="div-icon-button">
        <div class="save" (click)="setCorporationResponsibleOrganization()">
          {{ getLanguages('save')}}
        </div>
        <i class="fas fa-xmark" (click)="createResponsibleOrganogram = false"></i>
      </div>
      </div>

    <div class="modal-create-row">
      <div class="modal-create-title">
        {{ getLanguages('businessSolution/modal/rules/titleNewResponsibleOrganization') }}
      </div>
    </div>

    <div class="modal-create-row">
      <div class="modal-create-item">
        <span> {{ getLanguages('businessSolution/modal/rules/titleNewResponsibleOrganization') }}</span>
        <input type="text" [(ngModel)]="newOrganizationResponsible.name">
      </div>
    </div>
  </div>
</div>